// removed by extract-text-webpack-plugin
module.exports = {"standard":"Form_standard_U5QY0","small":"Form_small_3BKlp"};